import React from "react";
import { Chip } from "@mui/material";

const statusColors = {
  paid: { background: "#cbf5c9", border: "#80c88a", text: "#06402B" },
  open: { background: "#d6ecff", border: "#87bdf7", text: "#1565c0" },
  void: { background: "#e6e6fc", border: "#9b9bf0", text: "#303f9f" },
  uncollectible: { background: "#ffe4c2", border: "#ffb74d", text: "#f57c00" },
  draft: { background: "#e1e7ed", border: "#a8b3c4", text: "#455a64" },
  deleted: { background: "#fab4b1", border: "#e57373", text: "#d32f2f" },
  refunded: { background: "#fce4ec", border: "#f48fb1", text: "#c2185b" },
  processing: { background: "#e1e7ed", border: "#a8b3c4", text: "#455a64" },
};

const InvoiceStatusCell = ({ status, t, refunded }) => {
  const displayStatus = refunded ? 'refunded' : status;
  const translatedStatus = t(displayStatus);
  const color = statusColors[displayStatus] || { background: "black", border: "gray", text: "white" };

  return (
    <Chip
      label={translatedStatus}
      style={{
        backgroundColor: color.background,
        color: color.text,
        border: `1px solid ${color.border}`,
      }}
    />
  );
};

export default InvoiceStatusCell;
